import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './components/App';
import '../scss/app.scss';

const root = createRoot(document.getElementById('storefront'));

root.render(<App />);
